import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#5A3FA0]" data-id="element-28">
          ANTES VS DESPUÉS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-29">
          {/* Antes */}
          <div className="bg-white rounded-2xl p-5 shadow-lg border-t-8 border-red-500" data-id="element-30">
            <h3 className="text-2xl font-bold mb-3 text-red-600 text-center border-b pb-3" data-id="element-31">
              Antes de Efemérides Listas Secundaria
            </h3>
            <ul className="space-y-2 text-lg text-gray-700" data-id="element-32">
              <li className="flex items-start" data-id="element-33">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-34" />
                <span data-id="element-35">Improvisar actividades.</span>
              </li>
              <li className="flex items-start" data-id="element-36">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-37" />
                <span data-id="element-38">Buscar material en distintos sitios.</span>
              </li>
              <li className="flex items-start" data-id="element-39">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-40" />
                <span data-id="element-41">Encontrar propuestas infantiles.</span>
              </li>
              <li className="flex items-start" data-id="element-42">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-43" />
                <span data-id="element-44">Repetir siempre las mismas actividades.</span>
              </li>
              <li className="flex items-start" data-id="element-45">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-46" />
                <span data-id="element-47">Perder horas preparando cada fecha.</span>
              </li>
            </ul>
          </div>

          {/* Después */}
          <div className="bg-white rounded-2xl p-5 shadow-lg border-t-8 border-green-500 transform md:scale-105" data-id="element-48">
            <h3 className="text-2xl font-bold mb-3 text-green-600 text-center border-b pb-3" data-id="element-49">
              Después de Efemérides Listas Secundaria
            </h3>
            <ul className="space-y-2 text-lg text-gray-900 font-medium" data-id="element-50">
              <li className="flex items-start" data-id="element-51">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-52" />
                <span data-id="element-53">Efemérides organizadas durante todo el año.</span>
              </li>
              <li className="flex items-start" data-id="element-54">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-55" />
                <span data-id="element-56">Actividades listas para imprimir.</span>
              </li>
              <li className="flex items-start" data-id="element-57">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-58" />
                <span data-id="element-59">Propuestas pensadas para secundaria.</span>
              </li>
              <li className="flex items-start" data-id="element-60">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-61" />
                <span data-id="element-62">Más análisis y pensamiento crítico.</span>
              </li>
              <li className="flex items-start" data-id="element-63">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-64" />
                <span data-id="element-65">Menos tiempo buscando material.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}